export const GROUP_BY_KEYS = ['groupId', 'tagIds'];
export const DOMAIN = 'ENTITIES/CHILDREN';
